import { ThemeColors } from '../theme-colors';

export const Datepicker = {
	datepickerBackground: ThemeColors.white,
	datepickerDayFont: ThemeColors.black,
	datepickerDayFontDisabled: '#CBCBCB',
	datepickerDayPseudoSelected: '#EEEEEE',
	datepickerDayPseudoHighlighted: '#E2E2E2',
};

export const CustomDatepicker = {};
